// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainStopAssignment } from './TrainStopAssignment';
import {
    TrainStopAssignmentFromJSON,
    TrainStopAssignmentFromJSONTyped,
    TrainStopAssignmentToJSON,
    TrainStopAssignmentToJSONTyped,
} from './TrainStopAssignment';
import type { Quay } from './Quay';
import {
    QuayFromJSON,
    QuayFromJSONTyped,
    QuayToJSON,
    QuayToJSONTyped,
} from './Quay';
import type { NavigationPathAssignment } from './NavigationPathAssignment';
import {
    NavigationPathAssignmentFromJSON,
    NavigationPathAssignmentFromJSONTyped,
    NavigationPathAssignmentToJSON,
    NavigationPathAssignmentToJSONTyped,
} from './NavigationPathAssignment';

/**
 * Passing a `ScheduledStopPoint` on a `ServiceJourney` may have two 'views': one for arrival and one for departure aspects (aka OJP LegAlight::StopPoint, LegBoard::StopPoint; NeTeX Call (which is a VIEW on a `ScheduledStopPoint`).
 * @export
 * @interface StopCall
 */
export interface StopCall {
    /**
     * Date/time ([ISO-8601](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6) UTC with time-numoffset (like '+02:00')) **planned**, relates to `timeRt` (might be null for e.g. in virtual stops).
     * @type {Date}
     * @memberof StopCall
     */
    timeAimed?: Date;
    /**
     * Date/time ([ISO-8601](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6) UTC with time-numoffset (like '+02:00')) in **realtime** (oversteers related `timeAimed`!).
     * @type {Date}
     * @memberof StopCall
     */
    timeRt?: Date;
    /**
     * Formatted passenger message about the delay (may also relate to `ScheduledStopPoint::delayUndefined`) in the role of this call according to SBB business rules.
     * @type {string}
     * @memberof StopCall
     */
    delayText?: string;
    /**
     * 
     * @type {Quay}
     * @memberof StopCall
     */
    quayAimed?: Quay;
    /**
     * 
     * @type {Quay}
     * @memberof StopCall
     */
    quayRt?: Quay;
    /**
     * Related to `quayAimed` and `quayRt`.**false** even if the related `StopCall::quayRt` is set, this is not considered a realtime change (acc. to SBB busines rules); **true** real `*QuayRt` change, also see `ServiceAlteration::quayChangedFormatted`.
     * @type {boolean}
     * @memberof StopCall
     */
    quayChanged: boolean;
    /**
     * Principally same as related `Quay::name` (where rt wins over aimed), but in case of wing-trains (de:Flügelzüge) specified with **direction specific boarding-sections**.<br>(For e.g. 'Bern to Zweisimmen' with a split of train-composition at Spiez where customers might reach the wrong destination if they board the wrong car!)
     * @type {string}
     * @memberof StopCall
     */
    quayFormatted?: string;
    /**
     * 
     * @type {TrainStopAssignment}
     * @memberof StopCall
     */
    trainStopAssignment?: TrainStopAssignment;
    /**
     * 
     * @type {NavigationPathAssignment}
     * @memberof StopCall
     */
    navigationPathAssignment?: NavigationPathAssignment;
}

/**
 * Check if a given object implements the StopCall interface.
 */
export function instanceOfStopCall(value: object): value is StopCall {
    if (!('quayChanged' in value) || value['quayChanged'] === undefined) return false;
    return true;
}

export function StopCallFromJSON(json: any): StopCall {
    return StopCallFromJSONTyped(json, false);
}

export function StopCallFromJSONTyped(json: any, ignoreDiscriminator: boolean): StopCall {
    if (json == null) {
        return json;
    }
    return {
        
        'timeAimed': json['timeAimed'] == null ? undefined : (new Date(json['timeAimed'])),
        'timeRt': json['timeRt'] == null ? undefined : (new Date(json['timeRt'])),
        'delayText': json['delayText'] == null ? undefined : json['delayText'],
        'quayAimed': json['quayAimed'] == null ? undefined : QuayFromJSON(json['quayAimed']),
        'quayRt': json['quayRt'] == null ? undefined : QuayFromJSON(json['quayRt']),
        'quayChanged': json['quayChanged'],
        'quayFormatted': json['quayFormatted'] == null ? undefined : json['quayFormatted'],
        'trainStopAssignment': json['trainStopAssignment'] == null ? undefined : TrainStopAssignmentFromJSON(json['trainStopAssignment']),
        'navigationPathAssignment': json['navigationPathAssignment'] == null ? undefined : NavigationPathAssignmentFromJSON(json['navigationPathAssignment']),
    };
}

  export function StopCallToJSON(json: any): StopCall {
      return StopCallToJSONTyped(json, false);
  }

  export function StopCallToJSONTyped(value?: StopCall | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeAimed': value['timeAimed'] == null ? undefined : ((value['timeAimed']).toISOString()),
        'timeRt': value['timeRt'] == null ? undefined : ((value['timeRt']).toISOString()),
        'delayText': value['delayText'],
        'quayAimed': QuayToJSON(value['quayAimed']),
        'quayRt': QuayToJSON(value['quayRt']),
        'quayChanged': value['quayChanged'],
        'quayFormatted': value['quayFormatted'],
        'trainStopAssignment': TrainStopAssignmentToJSON(value['trainStopAssignment']),
        'navigationPathAssignment': NavigationPathAssignmentToJSON(value['navigationPathAssignment']),
    };
}

